import { render, staticRenderFns } from "./DeclaracionTemporadaIndex.vue?vue&type=template&id=1bd1adfd"
import script from "./DeclaracionTemporadaIndex.vue?vue&type=script&lang=js"
export * from "./DeclaracionTemporadaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports